import React from "react";
import { connect } from "react-redux";
import { compose } from "redux";
import { withRouter } from "react-router-dom";

import * as runReducer from "containers/Run/reducer";
import * as setupReducer from "containers/Setup/reducer";

import TrendChart from "components/ForecastChart/TrendChart";

class TrendChartContainer extends React.PureComponent {
  render() {
    const { modelPlotData } = this.props;

    return <TrendChart {...this.props} />;
  }
}

const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    updateRunPlotType: (type) => dispatch(runReducer.updateRunPlotType(ownProps.id, type)),
    updateForecastTime: (time) => dispatch(setupReducer.updateForecastTime(ownProps.id, time)),
    updateForecastTimeUnit: (unit) => dispatch(setupReducer.updateForecastTimeUnit(ownProps.id, unit)),
    updateUseForecastLocalRatio: (val) => dispatch(setupReducer.updateUseForecastLocalRatio(ownProps.id, val)),
    updateForecastLocalRatio: (val) => dispatch(setupReducer.updateForecastLocalRatio(ownProps.id, val)),
    fetchForecast: () => dispatch(runReducer.fetchForecast(ownProps.id))
  };
};

const mapStateToProps = (state, ownProps) => {
  const models = runReducer.getTransformedSortedModels(state, ownProps.id);
  const bestModel = models && models.length > 0 ? models[0] : undefined;

  const featureModel = runReducer.getFeatureSelection(state, ownProps.id, true);
  const chooseModel =
    models.filter((m) => m.id === featureModel).length > 0 ? models.filter((m) => m.id === featureModel)[0] : undefined;

  return {
    models: models,
    model: chooseModel ? chooseModel : bestModel,
    setupLabels: setupReducer.getSetupLabels(state, ownProps.id),
    currentRatio: setupReducer.getCurrentRatio(state, ownProps.id),
    forecastTime: setupReducer.getForecastTime(state, ownProps.id),
    forecastTimeUnit: setupReducer.getForecastTimeUnit(state, ownProps.id),
    forecastTimeOptions: setupReducer.getForecastTimeOptions(state, ownProps.id),
    forecastTimeCol: setupReducer.getForecastTimeCol(state, ownProps.runId),
    forecastResults: runReducer.getForecastResults(state, ownProps.id),
    forecastTrendPlot: runReducer.getForecastTrendPlot(state, ownProps.id),
    useForecastLocalRatio: setupReducer.getUseForecastLocalRatio(state, ownProps.id),
    forecastLocalRatio: setupReducer.getForecastLocalRatio(state, ownProps.id),
    madlibs: setupReducer.getMadLibs(state, ownProps.id),
    forecastChartDateRange: runReducer.getForecastChartDateRange(state, ownProps.id)
  };
};

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export default compose(withConnect, withRouter)(TrendChartContainer);
